import PropTypes from 'prop-types';
import { Rating } from '@bwoty-web/ui-kit';
import uniqid from 'uniqid';

import './informationPanel.scss';

const InformationPanel = (props) => {
  const { title, subtitle, rating, uspList } = props;

  const renderUspList = () => {
    if (!uspList) {
      return null;
    }

    return (
      <ul className="po-list-usp-list">
        {uspList.map((usp, i) => {
          if (!usp || usp === '') {
            return null;
          }
          return (
            <li
              className="po-list-usp-list-item"
              key={uniqid('po-list-usp-list-item-')}
            >
              {usp}
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <div className="po-list-information-panel">
      <div className="po-list-title">{title}</div>
      <Rating
        rating={rating}
        className="po-list-rating"
        size="small"
        responsive
      />
      <div className="po-list-subtitle">{subtitle}</div>
      {renderUspList()}
    </div>
  );
};

InformationPanel.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  rating: PropTypes.number.isRequired,
  uspList: PropTypes.arrayOf(PropTypes.string),
};

InformationPanel.defaultProps = {
  uspList: null,
};

export default InformationPanel;
